import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { FieldType, IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";

const MasterFSPSearchForm = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const searchCriteria = masterFSPState.searchCriteria;

    const memoSubChgTypeOptions = useMemo(() => {
        if (!searchCriteria.chargeType) {
            const allCommonSubChgTypeOptions = Object.values(masterFSPState.dynamicOptions.subChargeTypeDropdownOptions).flat();
            return allCommonSubChgTypeOptions;
        }
        const subChgTypeOptions = searchCriteria.chargeType ? masterFSPState.dynamicOptions.subChargeTypeDropdownOptions[searchCriteria.chargeType] : [];
        return subChgTypeOptions;
    }, [searchCriteria.chargeType, masterFSPState.dynamicOptions.subChargeTypeDropdownOptions])


    const memoEffectiveDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={MasterFSPMaintenanceConstant.EFFECTIVE_DATE_RANGE}
                width='390px'
                fieldNames={{ startField: "effectiveDateFrom", endField: "effectiveDateTo" }}
                dateRange={{ startDate: searchCriteria.effectiveDateFrom, endDate: searchCriteria.effectiveDateTo }}
                onDatesChange={masterFSPVM.onDateRangeChange}
            />
        </div>
        , [searchCriteria.effectiveDateFrom, searchCriteria.effectiveDateTo, masterFSPVM.onDateRangeChange])

    const memoShippingLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={false}
                readOnlyValue={searchCriteria?.shippingLine || ''}
                fieldValue={searchCriteria?.shippingLine || ''}
                fieldLabel={MasterFSPMaintenanceConstant.SHIPPING_LINE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shippingLine'}
                isShowOptional={false}
                maxLength={10}
                options={masterFSPState.dynamicOptions.shippingLineCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.shippingLine, masterFSPState.dynamicOptions.shippingLineCompanyDropdownOptions, masterFSPVM])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={false}
                readOnlyValue={searchCriteria?.chargeType || ''}
                fieldValue={searchCriteria?.chargeType || ''}
                fieldLabel={MasterFSPMaintenanceConstant.CHARGE_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                isShowOptional={false}
                isShowMissingError={true}
                maxLength={10}
                options={masterFSPState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
                    masterFSPVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)
                    masterFSPVM.onSearchFieldChange('subChargeType', '', fFullValue) 
                }} />
        </div>
        , [searchCriteria?.chargeType, masterFSPState.dynamicOptions.chargeTypeDropdownOptions, masterFSPVM])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={false}
                readOnlyValue={searchCriteria?.subChargeType || ''}
                fieldValue={searchCriteria?.subChargeType || ''}
                fieldLabel={MasterFSPMaintenanceConstant.SUB_CHARGE_TYPE}
                fieldType={FieldType.DROPDOWN}
                isShowOptional={false}
                fieldKey={'subChargeType'}
                maxLength={10}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.subChargeType, memoSubChgTypeOptions, masterFSPVM])


    return <>

        <CriteriaItemContainer>
            {memoChargeType}
            {memoSubChargeType}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoShippingLine}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoEffectiveDateFromTo}
        </CriteriaItemContainer>

    </>;
}
export default memo(MasterFSPSearchForm);